export default __webpack_public_path__ + "static/media/pool-res4.f7384744.jpg";